/**
 * @params 默认参数 yyyy-MM-dd HH:mm:ss
 * @params dateParam 字符串
 * */
let formatDatePlugin = {
  install (Vue, options) {
    Vue.prototype.formatDate = function (dateParam, paramStyle, symbol) {
      paramStyle = paramStyle || 'yyyy年MM月dd日'
      // console.log(dateParam)
      let date = new Date(dateParam)
      let yyyy = date.getFullYear()
      let MM = date.getMonth() + 1
      let dd = date.getDate()
      let HH = date.getHours()
      let mm = date.getMinutes()
      let ss = date.getSeconds()

      if (MM >= 1 && MM <= 9) {
        MM = `0${MM}`
      }
      if (dd >= 1 && dd <= 9) {
        dd = `0${dd}`
      }
      if (HH >= 0 && HH <= 9) {
        HH = `0${HH}`
      }
      if (mm >= 0 && mm <= 9) {
        mm = `0${mm}`
      }
      if (ss >= 0 && ss <= 9) {
        ss = `0${ss}`
      }
      if (symbol) {
        let newFullYear = date.getFullYear().toString().split('').splice(2, 2).join('')
        return paramStyle.replace(/yyyy/g, newFullYear).replace(/MM/g, MM).replace(/dd/g, dd).replace(/HH/g, HH).replace(/mm/g, mm).replace(/ss/g, ss)
      } else {
        return paramStyle.replace(/yyyy/g, yyyy).replace(/MM/g, MM).replace(/dd/g, dd).replace(/HH/g, HH).replace(/mm/g, mm).replace(/ss/g, ss)
      }
    }
    Vue.prototype.formatTimeLine = (date, hasTime) => {
      // console.log(date)
      // 当前时间
      var currentDate = new Date()
      // console.log('currentDate', currentDate)
      var currentYear = currentDate.getFullYear()
      var currentMonth = (currentDate.getMonth() + 1)
      var currentDateD = currentDate.getDate()
      var srcDate = new Date(date)
      var srcYear = srcDate.getFullYear()
      var srcMonth = (srcDate.getMonth() + 1)
      var srcDateD = srcDate.getDate()
      var ret = ''
      var timeExtraStr = Vue.prototype.formatDate(srcDate, 'HH:mm')
      // console.log('timeExtraStr', timeExtraStr)
      var dateObj = {}
      dateObj.endTime = Vue.prototype.formatDate(currentDate, 'yyyy-MM-dd')
      if (currentDate.getDay() === 0) {
        dateObj.startTime = Vue.prototype.formatDate(currentDate.setDate(currentDate.getDate() - currentDate.getDay() - 6), 'yyyy-MM-dd')
      } else {
        dateObj.startTime = Vue.prototype.formatDate(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1), 'yyyy-MM-dd')
      }
      var srcTimestamp = srcDate.getTime()
      /*
      if ((new Date(dateObj.startTime + ' ' + '00:00:00').getTime() <= srcTimestamp) && (srcTimestamp <= new Date((dateObj.endTime + ' ' + '23:59:59')).getTime())) {
        var weekday = new Array(7)
        weekday[0] = '星期日'
        weekday[1] = '星期一'
        weekday[2] = '星期二'
        weekday[3] = '星期三'
        weekday[4] = '星期四'
        weekday[5] = '星期五'
        weekday[6] = '星期六'
        // 取出当前是星期几
        var weekdayDesc = weekday[srcDate.getDay()]
        if (hasTime) {
          ret = weekdayDesc + ' '
        } else {
          ret = weekdayDesc + ' ' + timeExtraStr
        }
      }
      */
      if (currentYear === srcYear) {
        if (currentMonth === srcMonth && currentDateD === srcDateD) {
          if (hasTime) {
            ret = '今天'
          } else {
            ret = Vue.prototype.formatDate(srcDate, 'HH:mm')
          }
        } else {
          var yesterdayDate = new Date()
          yesterdayDate.setDate(yesterdayDate.getDate() - 1)
          var twoDaysAgo = new Date()
          twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)
          var threeDaysAgo = new Date()
          threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
          var fourDaysAgo = new Date()
          fourDaysAgo.setDate(fourDaysAgo.getDate() - 4)
          var fiveDaysAgo = new Date()
          fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5)
          var sixDaysAgo = new Date()
          sixDaysAgo.setDate(sixDaysAgo.getDate() - 6)
          if (srcMonth === (yesterdayDate.getMonth() + 1) && srcDateD === yesterdayDate.getDate()) {
            if (hasTime) {
              ret = '昨天'
            } else {
              ret = '昨天' + ' ' + timeExtraStr
            }
          } else if (srcMonth === (twoDaysAgo.getMonth() + 1) && srcDateD === twoDaysAgo.getDate()) {
            if (hasTime) {
              ret = '2天前'
            } else {
              ret = '2天前' + ' ' + timeExtraStr
            }
          } else if (srcMonth === (threeDaysAgo.getMonth() + 1) && srcDateD === threeDaysAgo.getDate()) {
            if (hasTime) {
              ret = '3天前'
            } else {
              ret = '3天前' + ' ' + timeExtraStr
            }
          } else if (srcMonth === (fourDaysAgo.getMonth() + 1) && srcDateD === fourDaysAgo.getDate()) {
            if (hasTime) {
              ret = '4天前'
            } else {
              ret = '4天前' + ' ' + timeExtraStr
            }
          } else if (srcMonth === (fiveDaysAgo.getMonth() + 1) && srcDateD === fiveDaysAgo.getDate()) {
            if (hasTime) {
              ret = '5天前'
            } else {
              ret = '5天前' + ' ' + timeExtraStr
            }
          } else if (srcMonth === (sixDaysAgo.getMonth() + 1) && srcDateD === sixDaysAgo.getDate()) {
            if (hasTime) {
              ret = '6天前'
            } else {
              ret = '6天前' + ' ' + timeExtraStr
            }
          } else {
            var tomorrowDate = new Date()
            tomorrowDate.setDate(tomorrowDate.getDate() + 1)
            if (srcMonth === (tomorrowDate.getMonth() + 1) && srcDateD === tomorrowDate.getDate()) {
              if (hasTime) {
                ret = '明天'
              } else {
                ret = '明天' + ' ' + timeExtraStr
              }
            } else {
              // 今天是本周的第几天
              // var nowDayOfWeek = currentDate.getDay()
              if ((new Date(dateObj.startTime + ' ' + '00:00:00').getTime() <= srcTimestamp) && (srcTimestamp <= new Date((dateObj.endTime + ' ' + '23:59:59')).getTime())) {
                // var weekday = new Array(7)
                // weekday[0] = '星期日'
                // weekday[1] = '星期一'
                // weekday[2] = '星期二'
                // weekday[3] = '星期三'
                // weekday[4] = '星期四'
                // weekday[5] = '星期五'
                // weekday[6] = '星期六'
                // // 取出当前是星期几
                // var weekdayDesc = weekday[srcDate.getDay()]
                // ret = weekdayDesc + '' + timeExtraStr
              } else {
                if (hasTime) {
                  ret = Vue.prototype.formatDate(srcDate, 'yyyy-MM-dd')
                } else {
                  ret = Vue.prototype.formatDate(srcDate, 'yyyy-MM-dd HH:mm')
                }
              }
            }
          }
        }
      } else {
        ret = Vue.prototype.formatDate(srcDate, 'yyyy-MM-dd HH:mm')
      }
      // console.log(ret)
      return ret
    }
    Vue.prototype.formatTime = function (param) {
      let y = param.getFullYear()
      let m = param.getMonth() + 1
      let d = param.getDate()
      m = m < 10 ? ('0' + m) : m
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    }
    Vue.prototype.getFormatDate = function (param) {
      const date = new Date()
      let endTime = Vue.prototype.formatTime(date)
      let date1 = Date.parse(date)
      let start = ''
      let end = ''
      let oneDay = 1000 * 3600 * 24

      switch (param) {
        // 今天
        case 'today':
          start = new Date()
          break
          // 最近2天
        case 'lastTwoDay':
          start = date1 - oneDay * 2
          break
          // 最近1周
        case 'lastOneWeek':
          start = date1 - oneDay * 7
          break
          // 最近2周
        case 'lastTwoWeek':
          start = date1 - oneDay * 14
          break
          // 最近1月
        case 'lastOneMonth':
          start = new Date()
          start.setMonth(start.getMonth() - 1)
          break
          // 最近2月
        case 'lastTwoMonth':
          start = new Date()
          start.setMonth(start.getMonth() - 2)
          break
          // 最近3月
        case 'lastThreeMonth':
          start = new Date()
          start.setMonth(start.getMonth() - 3)
          break
          // 最近半年
        case 'lastHalfYear':
          start = new Date()
          start.setMonth(start.getMonth() - 6)
          break
          // 最近一年
        case 'lastOneYear':
          start = new Date()
          start.setYear(start.getFullYear() - 1)
          break
          // 本周
        case 'thisWeek':
          let a = 6 - date.getDay()
          start = new Date(date1 - oneDay * a).setHours(0, 0, 0, 0)
          end = new Date(date1 + oneDay * (1 + date.getDay())).setHours(24, 0, 0, 0)
          break
          // 本月
        case 'thisMonth':
          start = new Date()
          start.setHours(0, 0, 0, 0)
          start.setMonth(start.getMonth(), 1)
          end = new Date(start)
          end.setHours(0, 0, 0, 0)
          end.setMonth(start.getMonth() + 1, 1)
          break
          // 本年
        case 'thisYear':
          start = new Date()
          start.setHours(0, 0, 0, 0)
          start.setMonth(0, 1)
          start.setYear(start.getFullYear())
          end = new Date(start)
          end.setHours(0, 0, 0, 0)
          end.setMonth(start.getMonth(), 1)
          end.setYear(start.getFullYear() + 1)
          break
      }

      return {
        startTime: Vue.prototype.formatTime(new Date(start)) + ' ' + '00:00:00',
        endTime: end ? Vue.prototype.formatTime(new Date(end)) : endTime + ' ' + '23:59:59'
      }
    }
  }
}

export default formatDatePlugin



// WEBPACK FOOTER //
// ./src/plugins/DateFormatPlugin.js